import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { Module } from '../Module';
import { Subscriptions } from '../resources/Subscriptions';
import { IResult } from '../ServerApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';

export class ResumeSubscriptionAction {

  public static $inject = ['$translate', 'Subscriptions'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private Subscriptions: Subscriptions) { }

  public resumeSubscription(subscription: ISubscriptionInfo): ng.IPromise<IResult> {
    return this.Subscriptions.resume(subscription.id).then((result: IResult) => {
      if (!result.errors) {
        ToasterService.instance.pop({
          type: ToastType.Info,
          text: this.$translate.instant('subscriptionResumeSuccess', {
            SUBJECT: subscription.subject
          }),
          testId: 'resume-subscription-success'
        });
      }

      return result;
    });
  }

}

Module.instance().service('ResumeSubscriptionAction', ResumeSubscriptionAction);
